import React from "react";
import MeterInstellen from "./Components/MeterInstellen";

function IndexKampeerplaatsen() {
  return <MeterInstellen />;
}

export default IndexKampeerplaatsen;
